import { keyframes, styled } from '@acko-tech/building-blocks.ui.common';

const tabSwitchPulse = keyframes`
    0% { transform: scale(1); }
    50% { transform: scale(0.97); }
    100% { transform: scale(1); }
`;

export const TabRow = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-start;
    gap: 10px;
    margin-bottom: 0;
    flex-wrap: wrap;

    @media screen and (max-width: 769px) {
        flex-wrap: wrap;
        overflow-x: visible;
        padding-bottom: 0;
    }
`;

export const TabButton = styled.button<{ isActive: boolean }>`
    border: 1px solid #5d4aa8;
    background: ${({ isActive }) => (isActive ? '#5d4aa8' : '#f2edff')};
    width: auto;
    min-width: 104px;
    height: 36px;
    padding: 0 14px;
    border-radius: 999px;
    font-size: 14px;
    cursor: pointer;
    color: ${({ isActive }) => (isActive ? '#ffffff' : '#3f2f7f')};
    font-weight: ${({ isActive }) => (isActive ? 600 : 500)};
    box-shadow: ${({ isActive }) =>
        isActive ? '0 4px 10px rgba(93, 74, 168, 0.25)' : 'none'};
    transition: background 0.25s ease, color 0.25s ease, box-shadow 0.25s ease,
        transform 0.2s ease;

    &:active {
        animation: ${tabSwitchPulse} 0.25s ease;
    }

    @media screen and (max-width: 769px) {
        min-width: 86px;
        height: 32px;
        padding: 0 12px;
        font-size: 13px;
    }
`;

export const FilterCard = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    width: 100%;

    @media screen and (max-width: 769px) {
        border-radius: 10px;
        background: #faf9fd;
        border: 1px solid #ece9f4;
        padding: 12px;
        margin-top: 10px;

        .aggregateByDropdown {
            min-width: 100px;
            width: 120px;
            position: static;
            top: 0;
        }
    }

    .aggregateByDropdown {
        min-width: 140px;
        width: 160px;
        height: 36px;
        position: relative;
    }

    @media screen and (min-width: 770px) {
        .aggregateByDropdown {
            top: 8px;
        }
    }

    .monthDropdown {
        min-width: 140px;
        width: 140px;
        height: 34px;
    }

    .tagFilterDropdown {
        min-width: 160px;
        width: 160px;
    }
`;

export const DesktopTopRow = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
`;

export const MobileControlsWrapper = styled.div`
    width: 100%;
    margin-top: 10px;
`;

export const MobileTopRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
`;

export const MobileBottomRow = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 8px;
    flex-wrap: wrap;
`;

export const MobileApplyRow = styled.div`
    width: 100%;
    margin-top: 12px;
`;

export const MobileAggregateField = styled.div`
    flex: 1;
`;

export const MobileAggregateLabel = styled.div`
    color: #8c8c9b;
    font-size: 12px;
    white-space: nowrap;
`;

export const MobileApplyFiltersButton = styled.button`
    width: 100%;
    height: 34px;
    border: 0;
    border-radius: 8px;
    padding: 0 12px;
    color: #ffffff;
    background: #5d4aa8;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const ApplyFiltersButton = styled.button`
    height: 34px;
    border: 0;
    border-radius: 8px;
    padding: 0 16px;
    color: #ffffff;
    background: #5d4aa8;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    position: relative;
    top: 8px;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const FilterControls = styled.div`
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 8px;
    position: relative;
    z-index: 20;

    &.inlineControls {
        margin-top: 10px;
        width: 100%;
        flex-shrink: 1;
    }
`;

export const FiltersLabel = styled.div`
    color: #77778b;
    font-size: 14px;
    font-weight: 500;
    margin-right: 6px;
    position: relative;
    top: 8px;
`;

export const FilterField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const CalendarWrapper = styled.div`
    margin-top: 10px;
`;

export const FilterFieldLabel = styled.div`
    color: #7b62bd;
    font-size: 10px;
    font-weight: 500;
`;

export const Date = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
`;
